import {escapeHtml} from "./escapeHtml";
import {ShopBalloonData} from "./mapShopBalloon";
import styles from "../ui/ShopPlacemark.module.scss";

export const renderShopBalloon = (shop: ShopBalloonData): string => {
    const title = shop.name
        ? `<p class="${styles.balloonTitle}">${escapeHtml(shop.name)}</p>`
        : '';

    const address = shop.address
        ? `<p class="${styles.balloonAddress}">${escapeHtml(shop.address)}</p>`
        : '';

    const phone = shop.phone
        ? `<p class="${styles.balloonPhone}">Телефон: ${escapeHtml(shop.phone)}</p>`
        : '';

    const operatingMode = shop.operatingMode
        ? `<p class="${styles.balloonOperatingMode}">Время работы: ${escapeHtml(shop.operatingMode)}</p>`
        : '';

    return `
        <div class="${styles.balloon}">
            ${title}
            ${address}
            ${phone}
            ${operatingMode}
        </div>
    `;
};
